export const useStyles = {
  formControl:(width = '200px', backgroundColor = "#F9FBFF") => ({
    ".MuiInputBase-root": {
      fontSize: "12px",
      width,
      backgroundColor,
      borderRadius: "8px",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.09);"
      },
    },
    ".MuiSelect-select": {
      fontWeight: 600,
      color: '#1B3665',
    },
    ".MuiTypography-root": {
      fontSize: "12px",
      color: "#718096",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    ".MuiInputBase-root:before": {
      border: "none!important",
    },
    ".MuiInputBase-root:after": {
      border: "none!important",
    },
    "& .MuiSelect-select": {
      paddingTop: "7px",
      paddingBottom: "7px",
      borderRadius: "8px",
      lineHeight: "18px",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiInputBase-root": {
      borderBottom: "none",
    },
  }),

  select: {
    '.MuiSelect-filled': {
      paddingRight: '0',
    },
  },

  startAdornment: {
    marginTop: "0!important",
  },

  endAdornment: {
    marginRight: "10px",
  },

  menuItem: {
    fontSize: "14px",
  },

  clearIcon: {
    fontSize: "14px",
  },
};
